interface ThemeModeToggleProps {
  mode: 'light' | 'dark';
  onChange: (mode: 'light' | 'dark') => void;
  t: (key: string) => string;
}

export function ThemeModeToggle({ mode, onChange, t }: ThemeModeToggleProps) {
  return (
    <div className="inline-flex rounded-full border border-border bg-bgContainer p-0.5 text-sm">
      <button
        type="button"
        onClick={() => onChange('light')}
        className={`rounded-full px-4 py-1.5 font-medium transition-colors ${
          mode === 'light'
            ? 'bg-bgElevated text-textDefault shadow-sm'
            : 'text-textSecondary hover:text-textDefault'
        }`}
      >
        {t('themeSettings.previewLight')}
      </button>
      <button
        type="button"
        onClick={() => onChange('dark')}
        className={`rounded-full px-4 py-1.5 font-medium transition-colors ${
          mode === 'dark'
            ? 'bg-bgElevated text-textDefault shadow-sm'
            : 'text-textSecondary hover:text-textDefault'
        }`}
      >
        {t('themeSettings.previewDark')}
      </button>
    </div>
  );
}
